export const locationKeys = {
    all: ['locations'] as const,
    byUser: () => [...locationKeys.all, 'by-user'] as const,
    modal: () => [...locationKeys.all, 'modal'] as const,
    modalForOperators: (action: string, operatorIds: string[]) =>
        [...locationKeys.modal(), action, operatorIds] as const,
};
